// ─── Project Status ───────────────────────────────────────────────────────────
// Valid status transitions — enforced by Project Engine
export const PROJECT_STATUS_TRANSITIONS = {
    draft: ["geo_analysis"],
    geo_analysis: ["planning", "draft"],
    planning: ["simulation", "geo_analysis"],
    simulation: ["technical_review", "planning"],
    technical_review: ["economic_review", "simulation"],
    economic_review: ["ready_for_offer", "technical_review"],
    ready_for_offer: ["sent_to_servicehub", "economic_review"],
    sent_to_servicehub: ["offered", "ready_for_offer"],
    offered: ["accepted", "draft"],
    accepted: ["in_execution"],
    in_execution: ["commissioned"],
    commissioned: ["monitoring"],
    monitoring: ["archived"],
    archived: [],
};
// Approvals required before project can reach ready_for_offer
export const REQUIRED_APPROVALS_FOR_OFFER = [
    "roof_model",
    "structural_precheck",
    "economic_analysis",
    "material_list",
    "offer_export",
];
/** Aktuelle Schemaversion der semanticJson-Struktur. */
export const ROOF_SEMANTIC_VERSION = 1;
/**
 * Normalisiert beliebigen (auch fehlenden/alten `{}`-)Input auf die Vollstruktur
 * `{ version, edges, keepouts }`. Tolerant: unbekannte/defekte Felder → leere Arrays.
 * Garantiert, dass Leser nie über `undefined` stolpern (kein stiller Datenverlust).
 */
export function normalizeRoofSemanticData(raw) {
    const obj = (raw && typeof raw === "object" ? raw : {});
    const edges = Array.isArray(obj.edges) ? obj.edges : [];
    const keepouts = Array.isArray(obj.keepouts) ? obj.keepouts : [];
    const version = typeof obj.version === "number" ? obj.version : ROOF_SEMANTIC_VERSION;
    const disabledModules = Array.isArray(obj.disabledModules)
        ? obj.disabledModules.filter((x) => typeof x === "string")
        : [];
    return { version, edges, keepouts, disabledModules };
}
//# sourceMappingURL=domain.js.map